if (!customElements.get('model-images')) {
  class ModelImages extends HTMLElement {
    constructor() {
      super();
      this.currentModel = this.querySelector('[data-action="swap-model"]:checked')?.value;
    }
    
    connectedCallback() {
      this.addEventListener('change', e => {
        const model = e.target.value;
        if (!model.includes('model-') || !e.target.closest('[data-action="swap-model"]')) return;
        
        this.currentModel = model;
        this.toggleImages(model);
      });
      
      window.addEventListener('coco-shuffle:product-updated', () => {
        setTimeout(() => {
          if (!this.currentModel || this.closest('[data-show]')?.style.display === 'none') return;
          this.toggleImages();
        }, 100);
      });
      
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          this.toggleImages();
        }, 100);
      });
    }
    
    toggleImages(model = this.currentModel) {
      if (!model) return;
      document.querySelectorAll('[data-model-info]').forEach((el) => {        
        if (!el.dataset.modelInfo.includes('model-')) return;
        if (el.dataset.modelInfo === model) {
          el.style.display = null;
          return;
        }
        
        el.style.display = 'none';
      });
    }
  }
  
  customElements.define('model-images', ModelImages);
}
